import axios from './axios';

export const getValidationJs = () => {
  return axios.get<string>('/misc/validation').then((res) => res.data);
};
